module.exports = __webpack_public_path__ + "assets/4e4bc009366ee0036086cfb1d0e5b580.mp4";